function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { isType, SearchboxInputChangedAction, LiveSearchboxFilterAction, SearchSortingOptionChangedAction, FilteredSearchResultsReceivedAction, PartnerSearchResultsReceivedAction, ShowingResultsForReceviedAction, SearchSuggestionsRequestId } from '@shared/actions/actions';
import { initialSearchState, copyState } from '@src/State';
export default function searchReducer(state = initialSearchState, action) {
    const newState = copyState(state);
    if (isType(action, SearchboxInputChangedAction)) {
        // search box is being searched
        newState.searchText = action.payload.searchString;
        // leave the search results be, since they will be updated when new search results come in
        // however, when the dropdown is emptied out, clear the results.
        if (newState.searchText.length === 0) {
            newState.appSearchResults = [];
            newState.servicesSearchResults = [];
            newState.ecaSearchResults = [];
        }
        // make sure we only react to the latest request
        newState.searchIdCurrentlyOngoing = state.searchIdCurrentlyOngoing + 1;
    } else if (isType(action, LiveSearchboxFilterAction)) {
        newState.searchText = action.payload.searchText;
    } else if (isType(action, FilteredSearchResultsReceivedAction)) {
        if (newState.searchIdCurrentlyOngoing !== action.payload.searchid) {
            return state;
        } else {
            const { appSearchResults, servicesSearchResults, cloudsIndustrySearchResults, appsCount, servicesCount, cloudsIndustryCount, requestId } = action.payload;
            return _object_spread_props(_object_spread({}, newState), {
                filteredAppSearchResults: appSearchResults,
                filteredServicesSearchResults: servicesSearchResults,
                filteredCloudsIndustrySearchResults: cloudsIndustrySearchResults,
                appsCount,
                servicesCount,
                cloudsIndustryCount,
                requestId
            });
        }
    } else if (isType(action, PartnerSearchResultsReceivedAction)) {
        newState.partnerSearchResults = action.payload.partnerSearchResults;
    } else if (isType(action, ShowingResultsForReceviedAction)) {
        const { previousSearchText = '', showingResultsFor = '' } = action.payload;
        return _object_spread_props(_object_spread({}, newState), {
            showingResultsFor,
            previousSearchText,
            searchText: previousSearchText
        });
    } else if (isType(action, SearchSortingOptionChangedAction)) {
        newState.searchSortingOption = action.payload.searchSortingOption;
    } else if (isType(action, SearchSuggestionsRequestId)) {
        newState.suggestionsRequestId = action.payload.suggestionsRequestId;
    } else {
        return state;
    }
    return newState;
}
